import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoadingPage from '../views/loading-page.vue'


const routes = [
  {
    path: '/',
    name: '',
    component: LoadingPage
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/shooting',
    name: 'shooting',
    component: () => import('../views/ShootingView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
  
  { path: '/:pathMatch(.*)*', redirect: '/home' }, // Redirection des pages inconnues vers /home

]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
